import { Properties } from "@util/types";
import TravelExpense from "./TravelExpense";

export default class MiscExpense extends TravelExpense {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(props: Properties<MiscExpense>) {
		super(props);
	}

	static readonly type = "misc";

	override get displayName() {
		return "Sonstige Auslage";
	}

	static fromJson(data: any) {
		return new MiscExpense(TravelExpense.fromJson(data));
	}
}
